module.exports = __webpack_public_path__ + "img/propertyIndexTab4.1254dc07.png";